import { render } from "./SchemasTable.vue?vue&type=template&id=7ae71a70"
import script from "./SchemasTable.vue?vue&type=script&lang=js"
export * from "./SchemasTable.vue?vue&type=script&lang=js"

import "./SchemasTable.vue?vue&type=style&index=0&id=7ae71a70&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__